export function getFilterDetails(parameters: Record<string, any>, filterType: 'MENTION' | 'DASHBOARD'): string[] {
  const details: string[] = []

  if (filterType === 'MENTION') {
    if (parameters.datefrom || parameters.dateto) details.push('Data')
    if (parameters.hourfrom || parameters.hourto) details.push('Horário')
    if (parameters.brand?.length) details.push('Marca')
    if (parameters.polarity?.length) details.push('Polaridade')
    if (parameters.channel?.length) details.push('Canal')
    if (parameters.role?.length) details.push('Abordagem')
    if (parameters.approach?.length) details.push('Formato')
    if (parameters.grouptheme?.length) details.push('Grupo Temático')
    if (parameters.theme?.length) details.push('Tema')
    if (parameters.publisher?.length) details.push('Publicador')
    if (parameters.source?.length) details.push('Fonte')
    if (parameters.spokesperson?.length) details.push('Porta-Voz')
    if (parameters.profiles?.length) details.push('Perfis')
    if (parameters.content) details.push('Conteúdo')
    if (parameters.engagementType) details.push('Engajamento')
    if (parameters.hasChanges) details.push('Apenas com alterações')
    if (parameters.reviewed) details.push(parameters.reviewed === 'COM' ? 'Revisadas' : 'Não revisadas')
  } else if (filterType === 'DASHBOARD') {
    if (parameters.diaInfIN || parameters.mesInfIN || parameters.anoInfIN) details.push('Data início')
    if (parameters.diaSupIN || parameters.mesSupIN || parameters.anoSupIN) details.push('Data fim')
    if (parameters.horahinfin || parameters.horahsupin) details.push('Horário')
    if (parameters.idPolaridadeIN) details.push('Polaridade')
    if (parameters.idMarcaIN) details.push('Marca')
    if (parameters.idCanalIN) details.push('Canal')
    if (parameters.idPapelIN) details.push('Abordagem')
    if (parameters.idAbordagemIN) details.push('Formato')
    if (parameters.grupoTemaIN) details.push('Grupo Temático')
    if (parameters.idTemaIN) details.push('Tema')
    if (parameters.idPublicadorIN) details.push('Publicador')
    if (parameters.idDataSourceIN) details.push('Fonte')
    if (parameters.idConstraintIN) details.push('Porta-Voz')
    if (parameters.profilesIN?.length) details.push('Perfis')
    if (parameters.engagementType) details.push('Engajamento')
    if (parameters.k) details.push('Qtd Menções')
  }

  return details
}
